import { useInfiniteQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { GetProductsPaginated, RequestParamsGetProducts } from './types';

export function useInfiniteProducts(
    params: Omit<RequestParamsGetProducts, 'page'>,
) {
    const queryFn = async ({ pageParam }: { pageParam: number }) => {
        const response = await api.get<GetProductsPaginated>('/product', {
            params: {
                ...params,
                page: pageParam,
            },
        });

        return response.data;
    };

    return useInfiniteQuery({
        queryKey: [params],
        queryFn: ({ pageParam = 1 }) => queryFn({ pageParam }),
        getNextPageParam: (lastPage) => {
            const { next_page_url, current_page } = lastPage.meta;
            return next_page_url ? current_page + 1 : undefined;
        },
        refetchOnWindowFocus: false,
    });
}
